import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const SpringRewardsComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__springRewards"
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
    >
      <g clipPath="url(#clip0_2990_10068)">
        <path
          d="M2.49582 4.1284C2.36075 3.89228 2.1665 3.69489 1.9323 3.55615C2.16854 3.421 2.36572 3.22666 2.50431 2.99261C2.63949 3.22888 2.83389 3.42608 3.06801 3.56467C2.83155 3.69978 2.63436 3.89425 2.49582 4.1284Z"
          fill={colorVar}
          stroke={colorVar}
          strokeWidth="1.5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9945 5.5816C13.6093 2.2322 9.59678 2.37152 7.5905 5.10561L7.20573 5.62224C5.38634 8.25184 4.27601 9.98932 1 9.06055C2.77542 13.7509 7.44935 13.8569 10.5 10.0605C11.7154 8.67864 12 6.06055 14.9945 5.5816Z"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 13.5605C12 14.3887 12.672 15.0605 13.5004 15.0605C14.329 15.0605 15 14.3887 15 13.5605C15 12.7322 14.329 12.0605 13.5004 12.0605C12.672 12.0605 12 12.7322 12 13.5605Z"
          fill={colorVar}
        />
      </g>
      <defs>
        <clipPath id="clip0_2990_10068">
          <rect width="16" height="16" fill="white" transform="translate(0 0.0605469)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SpringRewards = withIcon(SpringRewardsComponent);
